import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'upuUserInitials',
})
export class UserInitialsPipe implements PipeTransform {
  transform(displayName: string | null | undefined): string {
    if (!displayName?.trim()) {
      return '';
    }

    const names = displayName.trim().split(/\s+/);

    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }

    const firstInitial = names[0].charAt(0).toUpperCase();
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();

    return firstInitial + lastInitial;
  }
}
